// extracted by mini-css-extract-plugin
module.exports = {"trading-widget-form-balance":"style_trading-widget-form-balance__k3Awo"};